var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumb',{style:({ margin: '20px 10px' })},[_c('BreadcrumbItem',[_vm._v("用户管理")]),_c('BreadcrumbItem',[_vm._v("添加用户")])],1),_c('loading',{attrs:{"loading":_vm.loading,"error":_vm.error}}),_c('formPage',{attrs:{"user":_vm.user,"companies":_vm.companies,"isSuperAdmin":_vm.isSuperAdmin},on:{"handleSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }